module.exports = __webpack_public_path__ + "img/framboise_done_closeup.60e03706.jpg";